import { useMemo } from 'react';
import { getAxiosClient } from '../http.client';
export class ComponentConfigClient {
    apiClient;
    async client() {
        if (this.apiClient)
            return this.apiClient;
        this.apiClient = getAxiosClient('admin/fluid-web/component-config');
        return this.apiClient;
    }
    async listComponents() {
        const client = await this.client();
        const response = await client.get('/');
        return response.data;
    }
    async getComponent(componentId) {
        const client = await this.client();
        const response = await client.get(`/${componentId}`);
        return response.data;
    }
    async createComponent(data) {
        const client = await this.client();
        await client.post('/create', data);
    }
    async deleteComponent(componentId) {
        const client = await this.client();
        await client.delete(`/${componentId}`);
    }
    async listInteractions(componentId, params) {
        const client = await this.client();
        const response = await client.get(`/${componentId}/interactions`, { params });
        return response.data;
    }
    async uploadExampleFile(componentId, file) {
        const client = await this.client();
        const formData = new FormData();
        formData.append('file', file);
        const response = await client.post(`/${componentId}/examples/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data.fileUri;
    }
    async addExample(componentId, example) {
        const client = await this.client();
        const response = await client.post(`/${componentId}/examples`, example);
        return response.data;
    }
    async deleteExample(componentId, exampleId) {
        const client = await this.client();
        await client.delete(`/${componentId}/examples/${exampleId}`);
    }
    async updateSettings(componentId, settings) {
        const client = await this.client();
        const response = await client.patch(`/${componentId}/settings`, settings);
        return response.data;
    }
    async getInteractionFileUrl(componentId, interactionId) {
        const client = await this.client();
        const response = await client.get(`/${componentId}/interactions/${interactionId}/file-url`);
        return response.data.url;
    }
}
export function useComponentConfigClient() {
    return useMemo(() => new ComponentConfigClient(), []);
}
